import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { CarouselControls, CarouselDots } from './ui/CarouselControls';
import { useCarousel } from '../hooks/useCarousel';
import { plannerSlides, plannerTags } from '../data/planners';
export function PlannerCarousel() {
  const {
    trackRef,
    activeIndex,
    scrollByCard
  } = useCarousel<HTMLUListElement>();
  return <Section className="py-14 sm:py-16 lg:py-20" data-id="element-74" data-mp="1md7xxnm1q54h">
      <SectionHeader title="No empieces tus planillas desde cero" intro="La guía incluye herramientas editables para que puedas pasar de investigar a realmente organizar tu viaje." data-id="element-75" data-mp="1mbwszkgv6rbs" />

      <ul className="mx-auto mt-7 flex max-w-[40rem] flex-wrap justify-center gap-2" data-id="element-76" data-mp="1w29f3h4busk1">
        {plannerTags.map(tag => <li key={tag} className="rounded-full bg-caribe/10 px-3 py-1.5 font-sans text-[10px] font-medium uppercase tracking-[0.12em] text-[#1f8f8a]" data-id="element-77" data-mp="1r4pywbo2k5pg">
            {tag}
          </li>)}
      </ul>

      <ul ref={trackRef} className="no-scrollbar mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 sm:mt-11" data-id="element-78" data-mp="213ov2urne8vk">
        {plannerSlides.map(slide => <li key={slide.title} className="w-[88%] shrink-0 snap-start sm:w-[62%] lg:w-[56%]" data-id="element-79" data-mp="3snrvnkiz7mu5">
            <figure className="flex h-full flex-col overflow-hidden rounded-xl border border-oceano/10 bg-white" data-id="element-80" data-mp="1hgm0zzwhdr7">
              <img src={slide.image} alt={`Vista de la plantilla ${slide.title}`} className="aspect-[16/9] w-full border-b border-oceano/10 object-cover object-left-top" loading="lazy" data-id="element-81" data-mp="6g9yqq7d50qb" />
              <figcaption className="flex items-start justify-between gap-4 p-4 sm:p-5" data-id="element-82" data-mp="fh86njkx9se6">
                <div data-id="element-83" data-mp="fevj8qweaptq">
                  <h3 className="font-display text-[19px] font-bold uppercase leading-none text-oceano sm:text-[21px]" data-id="element-84" data-mp="k7g7ze0g2cqe">
                    {slide.title}
                  </h3>
                  <p className="mt-2 font-sans text-[12.5px] leading-relaxed text-hierro" data-id="element-85" data-mp="u64d5c7byxco">
                    {slide.caption}
                  </p>
                </div>
                <span className="shrink-0 rounded-full bg-oceano px-2.5 py-1 font-sans text-[9px] font-medium uppercase tracking-[0.1em] text-polar" data-id="element-86" data-mp="z5gz7uqdo0e7">
                  {slide.tag}
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <div className="mt-5 flex items-center justify-between gap-4" data-id="element-87" data-mp="j7y2t1f5zsnv">
        <CarouselDots count={plannerSlides.length} activeIndex={activeIndex} data-id="element-88" data-mp="egg2mfkytw3y" />
        <CarouselControls onPrev={() => scrollByCard(-1)} onNext={() => scrollByCard(1)} data-id="element-89" data-mp="eebol4tcrgpy" />
      </div>
    </Section>;
}